import React, {Component} from 'react';
import '../../style.css';
import {Button, message, Modal, PageHeader, Space, Typography, Input, Tooltip, Tag, Form} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Paragraph } = Typography;

class RDCenterFound extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            RDData:[
                {
                    rdName: '',
                    companyName: "公司2",
                    time: '',
                }
            ],
            rdName: '',
            time: '',
            status:false,
            fileStream:'',
            preview_visible:false,
            fileStream_upload:'',
            fileField:[],
            upload_visible:false,
            uploadFile_visible:false,
            checkStatus:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
    componentDidMount() {
        fetchPost(global.constants.getRDCenterFoundR, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            RDData:res.data,
                            rdName:res.data.rdName,
                            time:res.data.time,
                        }))
                    }
                    else{
                        message.info("该材料未填写数据，请填写").then()
                        this.setState(()=>({
                            status:true,
                        }))
                    }
                }
            )
    }
    edit(){
        this.setState(()=>({
            status:true,
        }))
    }
    submit(){
        if(this.state.rdName === ''||this.state.time === ''){
            message.info("请检查信息是否填写完整").then()
        }else{
            let params={
                companyId:this.state.companyId,
                companyName:this.state.companyName,
                rdName:this.state.rdName,
                time:this.state.time
            }
            fetchPost(global.constants.updateRDCenterFound,params)
                .then(
                    res => {
                        if(res.code === 200) {
                            message.success("添加成功").then()
                            fetchPost(global.constants.getRDCenterFoundR, {companyId:this.state.companyId})
                                .then(
                                    res => {
                                        if(res.code === 200) {
                                            this.setState(()=>({
                                                RDData:res.data,
                                                status:false,
                                            }))
                                        }
                                    }
                                )
                        }
                    }
                )
        }
    }
    handleExportClick(){
        fetchPost(global.constants.exportRDCenterFoundR, {companyId:this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                    else{
                        message.info("生成失败，请先添加数据").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-22关于成立研发中心的通知.doc',
            fileName: '关于成立研发中心的通知.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    this.setState(()=>({
                        fileStream:res
                    }))
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-22关于成立研发中心的通知.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
            upload_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-22关于成立研发中心的通知.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/成立研发中心的通知.pdf',
                            fileName: '成立研发中心的通知.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    hideModalTwo(){
        this.setState(()=>({
            uploadFile_visible:false,
        }))
    }
    handleUploadClick(e){
        this.setState(()=>({
            upload_visible:true,
        }))
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'成立研发中心的通知',
            url:'',
        }
        fetchPost(global.constants.checkFile, params)
            .then(
                res => {
                    if(res.code === 200){
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'成立研发中心的通知',
                            url: '',
                            fileName: ''
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream_upload:blobUrl,
                                                checkStatus:true
                                            }))
                                        })
                                }
                            )
                    }
                    else{
                        this.setState(()=>({
                            fileStream_upload:'',
                            checkStatus:false,
                        }))
                    }
                })
    }
    fileInput(){
        this.setState(()=>({
            fileField:document.querySelector("input[type='file'][name='file']"),
            uploadFile_visible:true,
        }))
    }
    uploadFile(){
        const formdata = new FormData();
        formdata.append('file', this.state.fileField.files[0]);
        formdata.append('companyId',this.state.companyId);
        formdata.append('projectId',0);
        formdata.append('productId',0);
        formdata.append('patentId',0);
        formdata.append('otherId',0);
        formdata.append('remark','成立研发中心的通知');
        if (!(/pdf$/i.test(this.state.fileField.files[0].name))) {
            alert("只允许上传pdf格式的文件")
        } else{
            fetch(global.constants.uploadFile, {
                method: 'POST',
                body: formdata,
                mode: 'cors',
                credentials: 'include',
            })
                .then(res => res.json())
                .then(
                    res => {
                        if(res.code === 200){
                            message.success("上传成功").then();
                            let params = {
                                companyId:this.state.companyId,
                                projectId:0,
                                productId:0,
                                patentId:0,
                                otherId:0,
                                remark:'成立研发中心的通知',
                                url: '',
                                fileName: ''
                            }
                            fetchPostFile(global.constants.previewFile,params)
                                .then(
                                    res=>{
                                        res.blob().then(
                                            blob=> {
                                                let blobUrl = window.URL.createObjectURL(blob);
                                                this.setState(()=>({
                                                    fileStream_upload:blobUrl,
                                                    uploadFile_visible:false,
                                                    checkStatus:true,
                                                }))
                                            })
                                    }
                                )
                        }
                    })
        }
    }
    deleteUpload(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'成立研发中心的通知',
            url: '',
        }
        fetchPost(global.constants.deleteFile,params)
            .then(
                res=>{
                    if(res.code === 200){
                        message.success("删除成功").then()
                        this.setState(()=>({
                            checkStatus:false,
                        }))
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="成立研发中心的通知"
                        subTitle='可编辑生成或上传，只允许上传50M以内的pdf格式的文件'
                        extra={[
                            <Button type="primary"  onClick={this.handleUploadClick.bind(this)}>上传</Button>,
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Tooltip title="预览生成的文件">
                                <Button
                                    type="primary"
                                    onClick={this.handlePreviewClick.bind(this)}
                                >预览</Button>
                            </Tooltip>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：若两种方式的文件均存在，文件合成时系统自动选取上传的文件。</pre>
                    </Paragraph>
                </div>
                <div className="content-frame-wordStyle">
                    <div className="content-form-wordStyle">
                        <div className = "word">
                        <span className="word-title">
                            关于成立研发中心的通知
                        </span>
                        </div>
                        <Space direction="vertical" >
                            <Typography>
                                <Paragraph className="textStyle">
                                    为了公司研发能力的提高，促进我公司产品性能不断提成，
                                    研究和开发具有自主知识产权的新产品、新技术、新工艺，经公司董事会决定，
                                    成立“
                                    {
                                        this.state.RDData.rdName === null || this.state.status === true?
                                            <Input
                                                placeholder={'请填写研发中心名称'}
                                                defaultValue={this.state.RDData.rdName}
                                                autoSize={{ minRows: 1, maxRows: 2 }}
                                                onChange={this.rdNameChange.bind(this)}
                                            />:this.state.RDData.rdName
                                    }
                                    ”
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    一、研发中心职责
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1、根据市场和科学技术研究的需要，提出公司研发项目计划，包括项目立项的目的、
                                    依据、关键技术、创新点、人员和经费需求、资金筹措等。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2、根据公司生产和研发需要，积极与相关高校或科研院所联系、开展各种形式的产学研合作或研发项目合作。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    3、对于获得批准的项目，应成立项目组，负责研发项目的实施、成果验收和成果转化。
                                </Paragraph>
                                <Paragraph className="textStyle-bold">
                                    二、机构设置
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    1、研发中心设主任一名，副主任一名。主任由公司总经理兼任、副主任由主任指定人选。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    2、研发中心机构设置如下：
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    &nbsp;&nbsp;&nbsp;&nbsp;1）研发部：根据项目需求，成立项目组，并招聘或选拨公司技术人员作为项目组成员。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    &nbsp;&nbsp;&nbsp;&nbsp;2）财务部：由公司会计和出纳担任，并负责研发经费管理和核算。
                                </Paragraph>
                                <Paragraph className="textStyle">
                                    &nbsp;&nbsp;&nbsp;&nbsp;3）管理部：由公司人事部负责制定研发中心管理制度，并归口管理项目、
                                    人员和设备等管理制度的实施情况。
                                </Paragraph>
                                <div style={{float:'right',marginRight:'10%'}}>
                                    <Paragraph className="textStyle">
                                        {this.state.companyName}
                                    </Paragraph>
                                    <Paragraph className="textStyle">
                                        {
                                            this.state.RDData.time === null || this.state.status === true?
                                                <Input className="input_style"
                                                       placeholder={'请填写文件时间'}
                                                       defaultValue={this.state.RDData.time}
                                                       onChange={this.timeChange.bind(this)}/>:
                                                this.state.RDData.time
                                        }
                                    </Paragraph>
                                </div>
                            </Typography>
                            <div>
                                <Button type="primary" className="submit-edit-button" onClick={this.submit.bind(this)}>提交</Button>
                                <Button
                                    disabled={this.state.status}
                                    type="primary" className="submit-edit-button" onClick={this.edit.bind(this)}>编辑</Button>
                            </div>
                        </Space>
                        <Modal
                            visible={this.state.preview_visible}
                            title={'预览'}
                            onCancel={this.hideModal}
                            destroyOnClose
                            width={'50%'}
                            footer={[
                                <Button key="back" onClick={this.hideModal}>
                                    取消
                                </Button>,
                                <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                                    下载
                                </Button>,
                            ]}
                        >
                            <FileViewer fileType='pdf'
                                        filePath={this.state.fileStream}
                                        onError={this.onError}
                            />
                        </Modal>
                        <Modal
                            visible={this.state.upload_visible}
                            title={'上传附件'}
                            onCancel={this.hideModal.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModal.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.hideModal.bind(this)}>
                                    完成
                                </Button>,
                            ]}
                        >
                            <div>
                                该公司的成立研发中心的通知
                                {this.state.checkStatus === true?<Tag color="green" className="Tag_style">已上传</Tag>:<Tag color="red" className="Tag_style">未上传</Tag>}
                                <Form style={{marginTop:'20px'}}>
                                    <Form.Item
                                        name='file'
                                        method="post"
                                        enctype="multipart/form-data"
                                    >
                                        <input
                                            type="file"
                                            name='file'
                                            onChange={this.fileInput.bind(this)}
                                        />
                                    </Form.Item>
                                    <Form.Item name="preview_paper">
                                        {
                                            this.state.checkStatus === true &&
                                            <div>
                                                <Button type={"primary"} onClick={this.deleteUpload.bind(this)}>删除</Button>
                                                <FileViewer fileType='pdf'
                                                            filePath={this.state.fileStream_upload}
                                                            onError={this.onError}
                                                />
                                            </div>
                                        }
                                    </Form.Item>
                                </Form>
                            </div>
                        </Modal>
                        <Modal
                            visible={this.state.uploadFile_visible}
                            title={'上传'}
                            onCancel={this.hideModalTwo.bind(this)}
                            destroyOnClose
                            footer={[
                                <Button key="back" onClick={this.hideModalTwo.bind(this)}>
                                    取消
                                </Button>,
                                <Button key="submit" type="primary" onClick={this.uploadFile.bind(this)}>
                                    确定
                                </Button>,
                            ]}
                        >
                            <div>确定上传该成立研发中心的通知吗？</div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
    timeChange(e){
        const value = e.target.value
        this.setState(()=>({
            time:value
        }))
    }
    rdNameChange(e){
        const value = e.target.value
        this.setState(()=>({
            rdName:value
        }))
    }
}

export default RDCenterFound;